<div class="flex flex-col w-full h-full">
  <h1 class="mb-8 text-light-300 text-3xl font-medium">
    Profile & Settings <span class="text-xl text-red-100">(Demo Mode)</span>
  </h1>

  <div class="flex flex-col gap-10 grow">
    <div class="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'account-information',
          icon: 'profile',
          header: 'Account information',
          description: 'View and manage your personal details'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'preferences',
          icon: 'heart',
          header: 'Preferences',
          description: 'Customize language, currency, and notifications'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'security',
          icon: 'lock',
          header: 'Security and privacy',
          description: 'Setup additional security for your account'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'evaluate',
          icon: 'stars-rate',
          header: 'Rate us',
          description: 'Your review matters to us'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'evaluate',
          icon: 'pen-write',
          header: 'Submit feedback',
          description: 'Share your thoughts or request a feature'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'rewards/referrals',
          icon: 'gift',
          header: 'Refer a friend',
          description: 'Invite your friends and receive rewards'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'blog',
          icon: 'newspaper',
          header: 'Blog',
          description: 'Stay informed with industry insights and updates'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'glossary',
          icon: 'book',
          header: 'Glossary',
          description: 'Understand financial terms and concepts'
        }"
      />

      <ng-container
        [ngTemplateOutlet]="settingItem"
        [ngTemplateOutletContext]="{
          url: 'blog',
          icon: 'play',
          header: 'How it works',
          description: 'A visual guide to how we operate'
        }"
      />
    </div>

    <div class="flex flex-row gap-4 justify-end">
      <a
        class="text-light-100 bg-light-0 border border-light-180 hover:bg-light-180 rounded-full p-2 cursor-pointer"
      >
        <svg-icon src="assets/icons/facebook-logo.svg" svgClass="h-4 w-4" />
      </a>

      <a
        class="text-light-100 bg-light-0 border border-light-180 hover:bg-light-180 rounded-full p-2 cursor-pointer"
      >
        <svg-icon src="assets/icons/x-logo.svg" svgClass="h-4 w-4" />
      </a>

      <a
        class="text-light-100 bg-light-0 border border-light-180 hover:bg-light-180 rounded-full p-2 cursor-pointer"
      >
        <svg-icon src="assets/icons/instagram-logo.svg" svgClass="h-4 w-4" />
      </a>

      <a
        class="text-light-100 bg-light-0 border border-light-180 hover:bg-light-180 rounded-full p-2 cursor-pointer"
      >
        <svg-icon src="assets/icons/linked-in-logo.svg" svgClass="h-4 w-4" />
      </a>

      <a
        class="text-light-100 bg-light-0 border border-light-180 hover:bg-light-180 rounded-full p-2 cursor-pointer"
      >
        <svg-icon src="assets/icons/youtube-logo.svg" svgClass="h-4 w-4" />
      </a>
    </div>
  </div>
</div>

<ng-template
  #settingItem
  let-url="url"
  let-icon="icon"
  let-header="header"
  let-description="description"
>
  <!-- [href]="'home/profile/' + url" -->
  <a
    class="flex flex-col gap-2 w-full cursor-pointer bg-light-0 py-6 px-8 rounded-lg border-[1.5px] border-light-150 hover:border-blue-100"
  >
    <svg-icon
      [src]="'assets/icons/' + icon + '.svg'"
      svgClass="h-8 w-8 text-blue-100"
    />

    <p class="font-bold text-base text-light-300">{{ header }}</p>
    <p class="text-sm text-light-100">{{ description }}</p>
  </a>
</ng-template>
